import React, { FC, useEffect } from 'react';
import { getCookiesPolicy } from '../../../../doctrine/cookies/cookiesUtils';
import { displayCookieBannerWhenNeeded } from '../../../../doctrine/cookies/handleCookiesPolicy';
import {
  fetchIsLoggedIn,
  fetchEnvironment,
  fetchCurrentUser,
} from '../public.api';
import { activateTrackers, setTrackerFunctions } from './trackerFunctions';
import { UserType } from '../../../../doctrine/user/user.types';

export interface PublicustomWindow extends Window {
  logged_in: boolean;
  ENVIRONMENT_NAME: string;
  current_user: UserType;
}
declare let window: PublicustomWindow;

export const PublicCookiePolicy: FC = ({ children }) => {
  useEffect(() => {
    const init = async () => {
      const [isLoggedIn, environment, currentUser] = await Promise.all([
        fetchIsLoggedIn(),
        fetchEnvironment(),
        fetchCurrentUser(),
      ]);
      window.logged_in = isLoggedIn; // To work with the current system
      window.ENVIRONMENT_NAME = environment; // Needed to trigger Google Tag Manager
      window.current_user = currentUser;
      setTrackerFunctions();
      const acceptedTrackers = getCookiesPolicy();
      await activateTrackers(acceptedTrackers);
      displayCookieBannerWhenNeeded();
    };
    init();
  }, []);

  return (
    <>
      {children}
      {/* data-nosnippet is to prevent google to show the content in SERP */}
      <div data-react="cookies-banner" data-nosnippet />
    </>
  );
};
